// extracted by mini-css-extract-plugin
export default {"ul":"SidebarCategory_ul__FIIgf","label":"SidebarCategory_label__cxgNu"};